import { BaseControl } from '.';

/**
 * @typedef {object} SliderControlOptions
 * @property {number} [min] - Minimum value
 * @property {number} [max] - Maximum value
 * @property {number} [step] - Step increment
 * @property {string} [suffix] - Text shown after the value readout (e.g. '%')
 */

/**
 * Range slider with a live value readout next to it.
 * @extends {BaseControl<number, SliderControlOptions>}
 */
export class SliderControl extends BaseControl {

    /** @type {BaseControl<number>['render']} */
    render(value, onChange) {
        const current = value ?? this.defaultValue ?? 0;
        const suffix = this.options?.suffix ?? '';

        return (
            <label className="slider-control">
                {this.label}
                <div className="slider-control-row">
                    <input
                        type="range"
                        name={this.label}
                        value={current}
                        min={this.options?.min ?? 0}
                        max={this.options?.max ?? 100}
                        step={this.options?.step ?? 1}
                        onChange={(e) => onChange(Number(e.target.value))}
                    />
                    <span className="slider-control-value">
                        {current}{suffix}
                    </span>
                </div>
            </label>
        );
    }
}
